import { AfterViewInit, ChangeDetectionStrategy, Component, Inject, Input, OnDestroy } from '@angular/core';


import { SportConfigToken } from '@config/sport.config';

import { TranslateService } from '@ngx-translate/core';

import { OptaWidgetBase } from '../base.service';

declare const Opta: any;

@Component({
    selector: 'app-opta-match-teamsheet',
    templateUrl: './match-teamsheet.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OptaWidgetMatchTeamsheetComponent extends OptaWidgetBase implements AfterViewInit, OnDestroy {
    @Input()
        matchId: string | number | null | undefined;

    @Input()
        competitionId: string | number | null | undefined;

    @Input()
        seasonId: string | number | null | undefined;

    @Input()
        template = 'normal';

    #headlineTrans = 'web.opta_match_teamsheet';
    private transHeadline = '';


    public constructor(@Inject(SportConfigToken) public sportConfig: Record<string, any>,
        public translate: TranslateService) {
        super();
    }

    public ngAfterViewInit(): void {
        this.transHeadline = this.translate.instant(this.#headlineTrans);
        this.#headlineTrans = 'web.opta_match-teamsheet';
        setTimeout(() => {
            const element = document.querySelector('#opta-match-teamsheet') as HTMLElement;

            if (element) {
                element.innerHTML = this.getHtml();
                const optaWidgetTags = document.querySelector('opta-widget[load="false"]');

                if (optaWidgetTags) {
                    optaWidgetTags.removeAttribute('load');
                    Opta.start();
                }
            }
        });
    }

    ngOnDestroy(): void {
        if (Opta.widgets.ref_widget_match_teamsheet && this.template === 'normal') {
            Opta.widgets.ref_widget_match_teamsheet.destroy(true);
        }
    }

    getHtml(): string {
        return `

        <opta-widget widget="matchstats" widget_id="ref_widget_match_teamsheet" 
              competition="${this.competitionId}" season="${this.seasonId}" match="${this.matchId}" load="false" 
              template="teamsheet" live="true" side="both" navigation="tabs_more" default_nav="1" 
              show_match_header="false" show_score="false" show_halftime_score="false" 
              show_crests="false" show_team_formation="false" show_competition_name="false" 
              show_date="false" date_format="dddd D MMMM YYYY" narrow_date_format="DD/MM/YY" 
              show_goalkeepers="true" show_defenders="true" show_midfielders="true" 
              show_forwards="true" show_subs="true" 
              title="${this.transHeadline}" 
        rounding="1" sorting="false" competition_naming="abbr" team_naming="full" 
        player_naming="initial" show_live="false" show_logo="false" 
        show_title="true" breakpoints="400, 700" sport="football"></opta-widget>
              
        

             
              `;
    }
}
